function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useContext } from 'react';
import cn from 'classnames';
import { arrayOf, string, shape } from 'prop-types';
import { LoggedInContext } from '@immediate_media/component-config';
import DropDownNav from '../DropDownNav';
import Link from '../../atoms/Link';
import MenuLink from '../../atoms/MenuLink';
import List from '../List';
import Icon from '../../atoms/Icon';
import Image from '../../atoms/Image';
import Avatar from '../Avatar';
/**
 * AccountNav component.
 */

var _ref2 = /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(Icon, {
  className: "account-nav__icon mr-xs chromatic-ignore",
  color: "inherit",
  name: "profile",
  size: 25
}));

var AccountNav = function AccountNav(_ref) {
  var signInUrl = _ref.signInUrl,
      registerUrl = _ref.registerUrl,
      menuItems = _ref.menuItems,
      className = _ref.className,
      label = _ref.label,
      avatarImage = _ref.avatarImage;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAccountNavDropDown = _useState2[0],
      setShowAccountNavDropDown = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAccountNav = _useState4[0],
      setShowAccountNav = _useState4[1];

  var btnRef = useRef(null);
  var navId = 'account-dropdown';
  var isLoggedIn = useContext(LoggedInContext); // Hide the dropdown when clicking anywhere in the document, apart from the
  // button. If the click was a menu item we want to close and navigate, if it
  // was outside the menu we also want to close.

  var handleClick = function handleClick(evt) {
    if (btnRef.current && !btnRef.current.contains(evt.target)) {
      setShowAccountNavDropDown(false);
    }
  };

  useEffect(function () {
    document.addEventListener('click', handleClick, false);
    return function () {
      document.removeEventListener('click', handleClick, false);
    };
  }, []); // Renders the account nav in the client rather than SSR
  // to prevent unwanted caching of this component

  useEffect(function () {
    setShowAccountNav(true);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'account-nav')
  }, showAccountNav && (isLoggedIn ? /*#__PURE__*/React.createElement("div", {
    className: "account-nav__logged-in-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "body-copy-small account-nav__dropdown-btn",
    ref: btnRef,
    type: "button",
    onClick: function onClick() {
      setShowAccountNavDropDown(!showAccountNavDropDown);
    },
    "aria-haspopup": "true",
    "aria-controls": navId
  }, /*#__PURE__*/React.createElement("div", {
    className: "account-nav__avatar mr-xxs chromatic-ignore"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: avatarImage,
    noShadow: true
  })), label), /*#__PURE__*/React.createElement(DropDownNav, {
    className: 'account-nav__drop-down-nav' + (showAccountNavDropDown ? " account-nav__drop-down-nav--open" : ""),
    menuItems: menuItems,
    domId: navId,
    ariaLabel: "Account"
  })) : /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Account"
  }, /*#__PURE__*/React.createElement(List, {
    className: "account-nav__list",
    horizontal: true
  }, _ref2, /*#__PURE__*/React.createElement(List.Item, {
    className: "body-copy-small"
  }, /*#__PURE__*/React.createElement(Link, {
    href: signInUrl,
    className: "account-nav__link"
  }, "Sign in")), /*#__PURE__*/React.createElement(List.Item, {
    className: "account-nav__listitem body-copy-small"
  }, /*#__PURE__*/React.createElement(Link, {
    href: registerUrl,
    className: "account-nav__link"
  }, "Register"))))));
};

AccountNav.defaultProps = {
  menuItems: [],
  className: null,
  label: 'My Account',
  avatarImage: null
};
AccountNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** Menu items for the logged in state */
  menuItems: arrayOf(shape(MenuLink.propTypes)),

  /** Logged in label state */
  label: string,

  /** Sign in URL */
  signInUrl: string.isRequired,

  /** Register URL */
  registerUrl: string.isRequired,

  /** Avatar image props */
  avatarImage: shape(Image.propTypes)
} : {};
export default AccountNav;